<template>
    <v-container fluid class="pa-0">
        <fieldset class="px-2 mb-2">
            <legend class="settings-section subtitle-2 px-1" tabindex="0">
                General
            </legend>
            <v-row no-gutters class="py-1">
                <v-col class="px-2">
                    <slot name="title"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="billingAccountId"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="csgAccountId"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="pmsStatus"></slot>
                </v-col>
            </v-row>
        </fieldset>
        <fieldset class="px-2 mb-2">
            <legend class="settings-section text-subtitle-2 px-1" tabindex="0">
                Address info
            </legend>
            <v-row no-gutters class="py-1">
                <v-col class="px-2">
                    <slot name="addr1"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="addr2"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="city"></slot>
                </v-col>
            </v-row>
            <v-row no-gutters class="py-1">
                <v-col class="px-2">
                    <slot name="stateName"></slot>
                    <slot name="state"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="zip"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="phone"></slot>
                </v-col>
            </v-row>
        </fieldset>
        <fieldset class="px-2 mb-2">
            <legend class="settings-section text-subtitle-2 px-1" tabindex="0">
                Customer support info
            </legend>
            <v-row no-gutters class="py-1">
                <v-col class="px-2">
                    <slot name="supportNumber"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="supportEmail"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="supportWebUrl"></slot>
                </v-col>
            </v-row>
        </fieldset>
        <fieldset class="px-2 mb-2">
            <legend class="settings-section text-subtitle-2 px-1" tabindex="0">
                Misc...
            </legend>
            <v-row no-gutters class="py-1">
                <v-col class="px-2">
                    <slot name="defaultPublicChannelMapName"></slot>
                    <slot name="defaultPublicChannelMapId"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="defaultPrivateChannelMapName"></slot>
                    <slot name="defaultPrivateChannelMapId"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="rebootTime"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="ipv4AddressRange"></slot>
                </v-col>
                <v-col class="px-2">
                    <slot name="ipv6AddressRange"></slot>
                </v-col>
            </v-row>
        </fieldset>
    </v-container>
</template>

<script>
export default {
    name: 'SettingsLayout'
};
</script>
